import { GeoSearchResult } from './types'

export abstract class GeoSearchService {
  abstract get(query: string, langCode: string): Promise<GeoSearchResult[]>
}
